export default {
  // Hero Section
  contactHeroTitle: "Contact Us",
  contactHeroSubtitle: "We're here to help you navigate the complex world of pharmaceutical development. Whether you need API manufacturing, formulation development, or regulatory support, our team is ready to assist.",
  contactGetInTouchTitle: "Get in Touch",
  contactOurAddress: "Our Address",
  contactMainAddress: "67, Bazullah Road,<br />Partha Sarathy Puram,<br />T Nagar, Chennai – 600017<br />Tamil Nadu, India",
  contactOtherAddresses: "Other Addresses",
  contactAddressBangalore: "Phoenix Mall of Asia – Tower 2,<br />Level 6, Unit 602, Yelahanka Hobli,<br />Byatarayanapura, Bangalore – 560092,<br />Karnataka, India",
  contactAddressMumbai: "409, Bezzola Complex,<br />Sion Trombay Road,<br />Chembur, Mumbai - 400 071<br />Maharashtra, India.",
  contactAddressSwitzerland: "Bahnhof-Park 4,<br />Baar 6340,<br />Switzerland",
  contactEmail: "Email",
  
  // Form Section
  contactFormTitle: "Send us a Message",
  contactFormNameLabel: "Full Name *",
  contactFormNamePlaceholder: "Enter your full name",
  contactFormEmailLabel: "Email Address *",
  contactFormEmailPlaceholder: "Enter your email address",
  contactFormPhoneLabel: "Phone Number",
  contactFormPhonePlaceholder: "Enter your phone number",
  contactFormCompanyLabel: "Company",
  contactFormCompanyPlaceholder: "Enter your company name",
  contactFormMessageLabel: "Message *",
  contactFormMessagePlaceholder: "Tell us about your project or inquiry...",
  contactFormCharacters: "characters",
  contactFormSubmitButton: "Get in Touch",
  contactFormSubmitting: "Sending...",
  contactFormRecaptchaRequired: "Please complete reCAPTCHA",
  
  // Success/Error Messages
  contactFormSuccess: "Thank you! Your message has been sent successfully. We'll get back to you within 24 hours.",
  contactFormError: "Sorry, there was an error sending your message. Please try again or contact us directly.",
};

